import { Component, OnInit, ViewChild } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SettingsService } from '../../../../../core/services/settings.service';

@Component({
  selector: 'app-forgot-pin',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './forgot-pin.component.html',
  styleUrl: './forgot-pin.component.css'
})
export class ForgotPinComponent implements OnInit {
   @ViewChild('successModal') successModalTemplate: any;
  successMessage: string = '';

  pinForm: FormGroup;
  showPinUI: boolean = false;
  currentPinType: 'NEW' | 'CONFIRM' = 'NEW';
  error: string = '';
  step: 'email' | 'verify' = 'email';
  loading = false;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private settingsService: SettingsService,
    private modalService: NgbModal
  ) {
    this.pinForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      verificationCode: ['', [Validators.required, Validators.minLength(6)]],
      newPin: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
      confirmPin: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]]
    }, {
      validators: this.pinMatchValidator
    });
  }
  ngOnInit(): void {
    this.settingsService.getUserProfile().subscribe({
      next: (profile) => {
        if (profile && profile.UserEmails[0].address) {
          this.pinForm.get('email')?.setValue(profile.UserEmails[0].address);
          this.sendForgotPin();
        }
      },
      error: (err) => {
        console.error('Failed to load user profile', err);
      }
    });
  }

  pinMatchValidator(form: FormGroup) {
    const newPin = form.get('newPin')?.value;
    const confirmPin = form.get('confirmPin')?.value;
    if (newPin !== confirmPin) {
      form.get('confirmPin')?.setErrors({ pinMismatch: true });
      return { pinMismatch: true };
    }
    return null;
  }

  sendForgotPin(): void {
    if (this.pinForm.get('email')?.invalid) return;
    this.loading = true;
    this.settingsService.forgotPin(this.pinForm.get('email')?.value).subscribe({
      next: () => {
        this.step = 'verify';
        this.loading = false;
      },
      error: err => {
        this.error = err.error?.error?.message || 'Failed to send reset email.';
        this.loading = false;
      }
    });
  }

  resetPin(): void {
    if (this.pinForm.invalid) return;
    this.loading = true;
    const email = this.pinForm.get('email')?.value;
    const verificationCode = this.pinForm.get('verificationCode')?.value;
    const newPin = this.pinForm.get('newPin')?.value;
    const confirmPin = this.pinForm.get('confirmPin')?.value;
    
    this.settingsService.resetPin(email, verificationCode, newPin, confirmPin).subscribe({
     next: () => {
        this.loading = false;
        this.successMessage = 'PIN updated successfully';
        this.modalService.open(this.successModalTemplate, { centered: true });
        this.activeModal.close();
      },
      error: err => {
         this.error = err.error?.error?.message || 'Failed to reset PIN';
        this.loading = false;
      }
    });
  }

 showSuccessModal(message: string) {
    this.successMessage = message;
    this.modalService.open(this.successModalTemplate, { centered: true });
  }
  openPinUI(type: 'NEW' | 'CONFIRM'): void {
    this.currentPinType = type;
    this.showPinUI = true;
  }

  closePinUI(): void {
    this.showPinUI = false;
  }

  getCurrentPinControl() {
    switch (this.currentPinType) {
      case 'NEW':
        return this.pinForm.get('newPin');
      case 'CONFIRM':
        return this.pinForm.get('confirmPin');
      default:
        return null;
    }
  }

  onKeyPressed(key: string): void {
    const control = this.getCurrentPinControl();
    if (!control) return;
    let currentValue = control.value || '';
    if (key === '<') {
      currentValue = currentValue.slice(0, -1);
    } else if (currentValue.length < 4) {
      currentValue += key;
    }
    control.setValue(currentValue);
  }

  showError(): boolean {
    return this.error.length > 0;
  }

  close(): void {
    this.activeModal.dismiss();
  }
}